import { Box, Image, LoadingBubbles } from '@domain-group/suit-theme'

interface ArtworkPagePreviewProps {
  accentColor: string,
  loading?: boolean,
  secondPreview?: boolean,
  url?: string,
}

const ArtworkPagePreview = (props: ArtworkPagePreviewProps) => {
  const {
    accentColor, loading, secondPreview, url,
  } = props

  return (
    <Box
      backgroundColor="transparent"
      display={secondPreview ? ['none', 'flex'] : 'flex'}
      justifyContent={['flexStart', 'center']}
      marginBottom="large"
      marginLeft="large"
      marginTop="small"
      style={{
        borderRadius: '5px',
        border: '1px solid',
        overflow: 'hidden',
        borderColor: '#ececec',
      }}
      width={['calc(100% - 32px)', 'calc(50% - 24px)']}
    >

      {loading && (
        <Box justifyContent="center" alignItems="center" height="460px">
          <LoadingBubbles color={accentColor || 'blue'} />
        </Box>
      )}

      {!loading && (
        <Image style={{ backgroundSize: 'contain' }} height="460px" url={url} />
      )}
    </Box>
  )
}

export default ArtworkPagePreview
